"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
ReorderableModuleListNavCtrl.$inject = ["$scope", "eventService", "localStorageService", "metricsService"];
BlueprintCurrentModuleNavCtrl.$inject = ["$window", "$route", "$location", "$rootScope", "$scope", "uiService", "orgService", "userService", "deeplinkService", "blueprintService", "entitlementsService", "urlService"];
MainEventContextNavCtrl.$inject = ["$rootScope", "$scope", "uiService", "blueprintService", "userService"];
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var _require = require('underscore'),
  findWhere = _require.findWhere;

/* @ngInject */
function MainEventContextNavCtrl($rootScope, $scope, uiService, blueprintService, userService) {
  var lastSelectedEvent = null;
  $scope.$on('$routeChangeSuccess', function () {
    $scope.navDescriptors = blueprintService.getNavHeadings('event');
  });

  // captured by directives#collapseOnEventChangeRequested
  $scope.selectEvent = function (event) {
    if (!event) {
      event = {};
    }
    $scope.$emit('eventChangeRequested');
    return lastSelectedEvent = event;
  };
  $scope.shouldShowNavItem = uiService.shouldShowNavItem;
  $rootScope.$watch('user', function (currentUser, oldUser) {
    if (currentUser && currentUser._id !== (oldUser || {})._id) {
      if (userService.matchesRoles([{
        globalRole: 'superadmin'
      }, {
        eventRole: 'manager'
      }, {
        eventRole: 'editor'
      }])) {
        return $scope.canAccessMarketplace = true;
      }
    }
    $scope.canAccessMarketplace = false;
  });

  // emitted by directives#collapseOnEventChangeRequested
  return $scope.$on('eventChangeContinue', function () {
    if (!lastSelectedEvent) {
      return;
    }
    return $scope.navigateHard($rootScope.getGeoOptimalEventUrl(lastSelectedEvent));
  });
}

/* @ngInject */
function BlueprintCurrentModuleNavCtrl($window, $route, $location, $rootScope, $scope, uiService, orgService, userService, deeplinkService, blueprintService, entitlementsService, urlService) {
  var updateNavFn = function updateNavFn() {
    var currentRouteDescriptor = $route.current ? $route.current.$$route : undefined;

    // presence used to determine whether to hide/show the nav branding
    $scope.routePath = currentRouteDescriptor ? currentRouteDescriptor.path : undefined;
    var currentRouteBlueprintMetadata = currentRouteDescriptor ? currentRouteDescriptor.blueprintMetadata : undefined;
    if (!currentRouteBlueprintMetadata) {
      return;
    }
    var module = currentRouteBlueprintMetadata.module,
      moduleKey = currentRouteBlueprintMetadata.moduleKey,
      controller = currentRouteBlueprintMetadata.controller,
      controllerKey = currentRouteBlueprintMetadata.controllerKey;
    $scope.module = module;
    $scope.moduleKey = moduleKey;
    $scope.controller = controller;
    $scope.controllerKey = controllerKey;

    // if the controller defines its own menu item, don't show tabs
    if (controller.bstgMenu) {
      $scope.navItems = [];
    } else {
      var headings = blueprintService.getControllerHeadings(moduleKey);
      $scope.navItems = headings.filter(function (ctrl) {
        return !ctrl.bstgMenu;
      });
    }

    // begin handling fullscreen query param
    var search = $location.search();
    var fullscreenItemTarget = search ? search.fullscreen : undefined;
    if (fullscreenItemTarget) {
      angular.element(document.body).addClass('maximized');
      switch (fullscreenItemTarget) {
        case 'controller':
        case 'true':
          return $scope.controller.fullscreen._active = true;
        case 'module':
          if (!$scope.module.fullscreen) {
            $scope.module.fullscreen = {};
          }
          return $scope.module.fullscreen._active = true;
        default:
          return $location.search('fullscreen', null);
      }
    } else {
      angular.element(document.body).removeClass('maximized');

      // set the query param based on which view is active (if any)
      if ($scope.controller.fullscreen._active) {
        $location.search('fullscreen', 'controller');
      }
      if ($scope.module.fullscreen._active) {
        return $location.search('fullscreen', 'module');
      }
    }
  };
  $rootScope.$watch('event', /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(currentEvent, oldEvent) {
      var orgId, currentUser, org, report, products, seats, seatReport, seatOverage, availableSeats;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(currentEvent && currentEvent.id !== (oldEvent || {}).id)) {
              _context.next = 23;
              break;
            }
            if (!(currentEvent && currentEvent.entitlements_enabled)) {
              _context.next = 23;
              break;
            }
            orgId = currentEvent.ownerId;
            currentUser = userService.getCurrentUser();
            org = findWhere(currentUser.orgs, {
              _id: orgId
            });
            if (!(!org || !org.entitlements_enabled)) {
              _context.next = 7;
              break;
            }
            return _context.abrupt("return");
          case 7:
            _context.next = 9;
            return entitlementsService.getEventUsageReport(currentEvent.id);
          case 9:
            report = _context.sent;
            if (!currentEvent.entitlements_v2) {
              _context.next = 21;
              break;
            }
            _context.next = 13;
            return entitlementsService.getPurchaseOrganizationProducts(orgId, 'subscription');
          case 13:
            products = _context.sent;
            // returns products with type 'subscription'
            // there can be only one product as the pools of seats are aggregated
            seats = products[0];
            seatReport = report.find(function (item) {
              return item.type === 'subscription';
            });
            seatOverage = (seatReport || {}).overage || 0;
            availableSeats = seats && seats.usage && seats.usage.available ? seats.usage.available : 0;
            $scope.shouldShowOverUsageNotice = availableSeats - seatOverage < 0;
            _context.next = 22;
            break;
          case 21:
            $scope.shouldShowOverUsageNotice = report.some(function (r) {
              return r.isOverUsage;
            });
          case 22:
            if (userService.matchesRoles([{
              orgRole: 'entitlement_manager',
              orgId: orgId
            }, {
              globalRole: 'superadmin'
            }, {
              isSpotme: true
            }])) {
              $scope.canViewEntitlements = true;
            }
          case 23:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
  $scope.navigateToEventEntitlementsManager = function () {
    var _$rootScope$event = $rootScope.event,
      id = _$rootScope$event.id,
      ownerId = _$rootScope$event.ownerId;
    var orgName = ownerId.replace(orgService.ORG_ID_PREFIX, '');
    var url = urlService.getTopLevelAppInstanceUrl("/org/".concat(orgName, "/entitlements/per-event-entitlements?eid=").concat(id));
    $scope.navigateHard(url);
  };
  updateNavFn();
  $rootScope.$on('$routeChangeSuccess', updateNavFn);
  $scope.shouldHideFullscreenControls = function () {
    // hide if we're using a deeplink in 'controller' fullscreen mode
    if (deeplinkService.isCurrentUrlAnAccreditedDeeplink()) {
      deeplinkService.rememberInAccreditedDeeplinkMode();
      if (deeplinkService.getCurrentBlueprintFullscreenMode() === 'module') {
        return false;
      }
      return true;
    }

    // we hide them in mobile safari's standalone app mode or if controller embeds them
    var currentControllerBlueprint = ((($route.current || {}).$$route || {}).blueprintMetadata || {}).controller;
    if (!currentControllerBlueprint) {
      return true;
    }
    return $window.navigator.standalone || currentControllerBlueprint.fullscreen && currentControllerBlueprint.fullscreen._embedded_controls;
  };
  $scope.toggleFullscreenModeForCurrentNavItem = function (navItemType, $event, forceOpen) {
    if (!navItemType) {
      navItemType = 'controller';
    }
    $event && $event.preventDefault();
    var moduleOrController = navItemType === 'controller' ? $scope.controller : $scope.module;
    if (!moduleOrController.fullscreen) {
      moduleOrController.fullscreen = {};
    }
    if (forceOpen) {
      moduleOrController.fullscreen._active = true;
    }
    var isActive = forceOpen || (moduleOrController.fullscreen._active = !moduleOrController.fullscreen._active);
    angular.element(document.body).toggleClass('maximized', isActive);
    $location.search('fullscreen', isActive ? navItemType : false);
    $rootScope.$applyAsync();
  };
  $scope.exitFullscreenModes = function () {
    if ($scope.module.fullscreen ? $scope.module.fullscreen._active : undefined) {
      $scope.module.fullscreen._active = false;
    }
    if ($scope.controller.fullscreen ? $scope.controller.fullscreen._active : undefined) {
      $scope.controller.fullscreen._active = false;
    }
    angular.element(document.body).removeClass('maximized');
    $location.search('fullscreen', null);

    // Called to change the URL in the browser to reflect
    // the new location value
    $rootScope.$applyAsync();
  };
  $scope.enterBrowserFullscreenMode = function () {
    return $scope.$emit('event:request-browser-full-screen:main-container');
  };
  $scope.logout = userService.logout;
  $scope.shouldShowNavItem = uiService.shouldShowNavItem;

  // Global fullscreen controls
  $rootScope.enterFullscreen = function (fullframe) {
    $scope.toggleFullscreenModeForCurrentNavItem(null, null, true);
    $rootScope.fullframeScreen = fullframe;
    if (fullframe) {
      $scope.enterBrowserFullscreenMode();
    }
  };
  $rootScope.exitFullscreen = function () {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      /* Firefox */
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      /* Chrome, Safari and Opera */
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      /* IE/Edge */
      document.msExitFullscreen();
    }
    if (!$rootScope.fullframeScreen) {
      return $scope.$root.exitFullscreenModes();
    }
  };
  $rootScope.exitFullscreenModes = $scope.exitFullscreenModes;
}

/* @ngInject */
function ReorderableModuleListNavCtrl($scope, eventService, localStorageService, metricsService) {
  var intermediateNavDescriptors = $scope.intermediateNavDescriptors = [];
  var getLocalStorageKey = function getLocalStorageKey() {
    var localStorageKey = 'userModuleOrderMap:';
    var eventId = (eventService.getCurrentEvent() || {}).id;
    if (!eventId) {
      return "".concat(localStorageKey, "root");
    }
    return localStorageKey + eventId;
  };
  $scope.toggleModuleReorderMode = function () {
    $scope.inModuleReorderMode = !$scope.inModuleReorderMode;
    if ($scope.inModuleReorderMode) {
      return $scope.revealAllModules = true;
    }
  };
  $scope.saveModuleOrdering = function (reorderedModuleKeys) {
    // tracking
    var hasChanges = !$scope.intermediateNavDescriptors.every(function (navItem, idx) {
      return reorderedModuleKeys[idx] === navItem.moduleKey;
    });
    metricsService.track('nav_module_reorder_save', {
      hasChanges: hasChanges
    });
    // /tracking

    var reorderedNavDescriptors = _.chain($scope.navDescriptors).sortBy(function (navDescriptor) {
      return reorderedModuleKeys.indexOf(navDescriptor.moduleKey);
    }).map(function (navDescriptor, idx) {
      navDescriptor = _.clone(navDescriptor);
      navDescriptor.order = idx;
      return navDescriptor;
    }).value();
    var reorderedNavOrderMappings = _.chain(reorderedNavDescriptors).map(function (navDescriptor) {
      return [navDescriptor.moduleKey, navDescriptor.order];
    }).object().value();
    $scope.intermediateNavDescriptors = reorderedNavDescriptors;
    return localStorageService.set(getLocalStorageKey(), reorderedNavOrderMappings);
  };
  $scope.navigateToModule = function ($clickEvent) {
    if ($scope.inModuleReorderMode) {
      if ($clickEvent) {
        $clickEvent.preventDefault();
      }
      return;
    }
    if (typeof $scope.collapseExtendedModuleDisplay === 'function') {
      $scope.collapseExtendedModuleDisplay();
    }
  };
  return $scope.$watch(function () {
    return JSON.stringify($scope.navDescriptors);
  }, function () {
    var newNavDescriptors = $scope.navDescriptors;
    // mutex to hold on replacing dom element order with that in navDescriptors array

    if (!newNavDescriptors || !newNavDescriptors.length || $scope.lastModuleReorderModeHandled !== $scope.inModuleReorderMode) {
      return;
    }
    var areOrdersSyncedWithDisplay = function areOrdersSyncedWithDisplay(userSavedOrderingsMap) {
      var activeOrderingsMap = _.chain(newNavDescriptors).map(function (navDescriptor) {
        return [navDescriptor.moduleKey, navDescriptor.order || 0];
      }).object().value();
      return angular.equals(activeOrderingsMap, userSavedOrderingsMap);
    };
    var customModuleOrderMap = localStorageService.get(getLocalStorageKey());
    if (customModuleOrderMap && !areOrdersSyncedWithDisplay(customModuleOrderMap)) {
      newNavDescriptors = _.chain(newNavDescriptors).map(function (navDescriptor /* , idx */) {
        var storedOrder = customModuleOrderMap[navDescriptor.moduleKey];
        navDescriptor = _.clone(navDescriptor);
        navDescriptor.order = _.isNumber(storedOrder) ? storedOrder : navDescriptor.order || 0;
        return navDescriptor;
      }).sortBy('order').value();
      return $scope.saveModuleOrdering(_.pluck(newNavDescriptors, 'moduleKey'));
    } else {
      return angular.copy(newNavDescriptors, intermediateNavDescriptors);
    }
  });
}
angular.module('backstage.controllers.main', []).controller('MainEventContextNavCtrl', MainEventContextNavCtrl).controller('BlueprintCurrentModuleNavCtrl', BlueprintCurrentModuleNavCtrl).controller('ReorderableModuleListNavCtrl', ReorderableModuleListNavCtrl);